// Loader.jsx
import React from "react";
// import "./Loader.css"; // Import the new CSS file

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;